import React, { useEffect } from "react";
import { useLoader } from "../context/LoaderContext";
import CommingSoon from "../components/CommingSoon";
import ObservershipBanner from "../components/academics/ObservershipBanner";

const Observership = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [setLoading]);
  return (
    <>
      <ObservershipBanner />
      <CommingSoon />
    </>
  );
};

export default Observership;
